import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Layout from "../Layout/index";
import MainWrapper from "./MainWrapper";

import LogIn from "../LogIn/index";
import ExamplePageOne from "../Example/index";
import ExamplePageTwo from "../ExampleTwo/index";
import AgendaAsignDay from "../AgendaAsignDay/index";
import Services from "../Services/index";
import ThirdParties from "../ThirdParties/index";
import PriceListPlans from "../PriceList/plan";
import PriceListServices from "../PriceList/components/PriceListForm/PriceListForm";
import Admissions from "../Admissions/SearchAdmissions/index";
import AddAdmission from "../Admissions/AddAdmission/index";
import AttachFileAdmission from "../Admissions/SearchAdmissions/components/AttachFileAdmission";
import ReceiptAdmission from "../Admissions/SearchAdmissions/components/ReceiptAdmission";
import FallingRisk from "../Admissions/SearchAdmissions/components/FallingRisk";
import CreatePatient from "../Patient/CreatePatient/index";
import PatientList from "../Patient/EditPatient/index";
import UpdatePatient from "../Patient/EditPatient/components/UpdatePatient";
import SearchClinicHistory from "../ClinicHistory/SearchClinicHistory/index";
import ClinicHistoryViewIps from "../ClinicHistory/ClinicHistoryViewIPS/index";
import ClinicHistoryView from "../ClinicHistory/ClinicHistoryView/index";
import Profile from "../Profiles/index";
import AddProfile from "../Profiles/components/AddProfile/AddProfile";
import Users from "../Users/index";
import AddUser from "../Users/AddUser/AddUser";
import UpdateUser from "../Users/AddUser/UpdateUser";
import Professionals from "../Professionals/index";
import EditProfessional from "../Professionals/professionalCreate/FormProfessional";
import ProfileAddModules from "../Profiles/components/ProfileAddModules/ProfileAddModules";
import DebitNotes from "../Billing/DebitNotes/SearchDebitNotes/index";
import AddDebitNote from "../Billing/DebitNotes/AddDebitNote/AddDebitNote";
import InvoiceCostumer from "../Billing/InvoiceCustomers/SearchInvoiceCostumers/index";
import ViewInvoice from "../Invoice/index";
import AddInvoiceCostumer from "../Billing/InvoiceCustomers/AddInvoiceCostumer/AddInvoiceCostumer";
import NotFound404 from "../DefaultPages/404/NotFound404";
import fakeAuth from "../../auth";
import { Navbar } from "../Billing/Invoice/components/index";
import InvoiceGenerator from "../Billing/Invoice/views/invoice-generator/invoice-generator";
import InvoiceList from "../Billing/Invoice/views/invoice-list/invoice-list";
import Settings from "../Billing/Invoice/views/settings/settings";
import ProfileConfiguration from "../Configuration/Profile/index";
import InvoiceConfiguration from "../Configuration/Invoices/index";
import EmailsConfiguration from "../Configuration/Emails/index";
import ClinicEvent from "../ClinicHistory/ClinicEvent/index";
import ThirdPartyForm from "../ThirdParties/components/ThirdPartyForm";
import ThirdPartiesUpdate from "../ThirdParties/components/ThirdPartiesUpdate";
import ProceduresView from "../ClinicHistory/ProceduresView";
import Dashboard from "../Dashboard/index";
import NuclearProcedures from "../NuclearProcedures/index";
import UserCalendar from "../DefaultPages/Calendar/index";
import Feasibility from "../Feasibility/index";
import AddFeasibility from "../Feasibility/components/AddFeasibility";
import DashboardFeasibility from "../Feasibility/components/DashboardFeasibility";
import Confidentiality from "../Feasibility/components/ConfidentialityAgreement/Confidentiality";
import ConfidentialityMe from "../Feasibility/components/ConfidentialityAgreement/ConfidentialityMe";
import ConfidentialityAgreement from "../Feasibility/components/ConfidentialityAgreement/ConfidentialityAgreement";
import FeasibilityQuestionary from "../Feasibility/components/FeasibilityQuestionary/FeasibilityQuestionary";
import RatingView from "../Feasibility/components/RatingView/RatingView";
import Budget from "../Feasibility/components/Budget/Budget";
import UserProfile from "../UserProfile/index";
import ResetPassword from "../LogIn/ResetPassword/index";
import EventAdverse from "../EventAdverse/index";
import EventAdverseForm from "../EventAdverse/components/EventAdverseForm";
import ReportEventAdvers from "../EventAdverse/components/ReportEventAdvers";
import GetEventAdverse from "../EventAdverse/components/GetEventAdverse";
import "bootstrap/js/dist/dropdown";
import Todo from "../Todo/index";
import "bootstrap/js/dist/dropdown";
import ClinicalStudio from "../ClinicalStudio/index";
import ShowClinicalStudio from "../ClinicalStudio/components/Show/index";
import RequirementsStudio from "../ClinicalStudio/components/Requirements/RequirementsStudio";
import RadioPharmacy from "../RadioPharmacy/ProductionOrder";
import Indicators from "../Indicators";
import Reports from "../Reports";
import CriterialExcludeInclude from "../ClinicalStudio/components/CriterialExcludeInclude/index";
import InformedConsent from "../ClinicalStudio/components/InformedConsent/index";
import Interview from "../Interview/Index";
import ClinicHistoryViewNuclear from "../ClinicHistory/ClinicHistoryViewNuclear/index";
import ClinicHistoryArdila from "../ClinicHistory/ClinicHistoryArdila/index";
import ForbiddenMedicine from "../ClinicalStudio/components/ForbiddenMedicine/index";
import DocumentManagement from "../ClinicalStudio/components/DocumentManagement/index";
import InvestingTeam from "../ClinicalStudio/components/InvestingTeam";
import ReceiptsList from "../Billing/Receipts/Index";
import Fees from "../Fees/index";
import DaicomViewer from "../DaicomViewer/index";
import ClinicHistoryComplete from "../ClinicHistory/ClinicHistoryComplete/index";
import ClinicHistoryControl from "../ClinicHistory/ClinicHistoryViewControl/index";
import StudyMonitors from "../ClinicalStudio/components/StudyMonitors/index";
import WorkSpaces from "../Workspaces/index";
import PatientsCall from "../PatientsCall";
import LivingRoom from "../LivingRoom";
import Templetes from "../Templetes/index";
import UpdateProfile from "../Profiles/components/UpdateProfile";
import ChangePassword from "../ChangePassword/index";
import RIPS from "../Rips/index";
import Settlement from "../SettlementSupport/index";
import QuickAccessService from "../QuickAccessServices/index";
import SpecialitiesList from "../Specialities/index";
import Quotes from "../Quotes/index";
import Medicines from "../Medicines/index";
import Rooms from "../Rooms/index";
import ImagingFileAdmision from "../Admissions/SearchAdmissions/components/ImagingFileAdmision";
import ContractForm from "../PriceList/index";
import AgendaConfig from "../AgendaConfig/index";
import MedicalServices from "../Professionals/MedicalServices/MedicalServices";
import Inventory from "../Inventory/index";
import ManualInvoice from "../ManualInvoice";
import Expenses from "../Expenses";
import ReportOperationsDiary from "../RadioPharmacy/OperationsDiary/index";
import ReportsPatients from "../ReportsPatients/index";
import AccountingAccount from "../AccountingAccounts/index";
import AccountsReport from "../AccountingAccounts/components/AccountsReport";
import Payments from "../Payments/Index";
import BillfoldPortfolio from "../Billfold/Index";
import Retention from "../Retention";
import QualityIndicators from "../QualityIndicators";
import MainDashbord from "../DisplayDashboardToUsers/MainDashbord";
import AccountStatusProfile from "../Billfold/components/AccountStatus/AccountStatusProfile";
import ShowPatientInformation from "../Patient/DisplayPatientInformation";
import ComplaintsAndClaims from "../ComplaintsAndClaims/index";
import FormComplaintsAndClaims from "../ComplaintsAndClaims/components/FormComplaintsAndClaims";
import ShowThridInformation from "../ThirdParties/components/DisplayThridInformation";
import SurveyPatients from "../SurveyPatients/index";
import DicomViewerV2 from "../DicomViewerV2";
import AdvancePayment from "../Billfold/AdvancePayment/AdvancePayment";
import PatientsPendingInvoice from "../Admissions/PatientsPendingInvoice";
import CreditNotes from "../CreditNotes/index";
import ClinicHistoryConfig from "../ClinicHistory/Config";
import ClinicalStudioEventAdverse from "../ClinicHistory/SearchClinicHistory/components/ClinicalStudioEventAdverse";
import RIPSpecificParameters from "../Rips/components/RIPSpecificParameters/RIPSpecificParameters";
import TechnicalSupport from "../TechnicalSupport";
import { DocumentManagementModule } from "../DocumentManagementModule";
import {
  ChangeHistory,
  ConsultDocumentos,
  Documentation,
} from "../GdDocumentation";
import { GdRoleManagement } from "../GdRoleManagement";
import { GdExternalDocumentation } from "../GdExternalDocumentation";
import { GdGestionDocumentos } from "../GdGestionDocumentos";
import { GdCargos } from "../GdCargos";
import { Register } from "../Register";
import { Proveedores } from "../Proveedores";

const Pages = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/agenda-asign-day`}
      component={AgendaAsignDay}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/update-professional`}
      component={EditProfessional}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/update-patient`}
      component={UpdatePatient}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/clinic-event`}
      component={ClinicEvent}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/medilcal-procedures`}
      component={ProceduresView}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/dashboard`}
      component={Dashboard}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/dashboard-users`}
      component={MainDashbord}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/procedures`}
      component={NuclearProcedures}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/pages/technical-support`}
      component={TechnicalSupport}
    />
  </Switch>
);

const Config = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/manage-profile`}
      component={Profile}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/proveedores`}
      component={Proveedores}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/charges`}
      component={GdCargos}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/profile`}
      component={ProfileConfiguration}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/add-modules`}
      component={ProfileAddModules}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/manage-users`}
      component={Users}
    />
  </Switch>
);

const Terceros = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/terceros/listar`}
      component={ThirdParties}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/terceros/crear`}
      component={ThirdPartyForm}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/terceros/form`}
      component={ThirdPartiesUpdate}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/config/terceros/display-profile`}
      component={ShowThridInformation}
    />
  </Switch>
);

const Admin = () => <Switch></Switch>;

const Assistencial = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/admissions`}
      component={Admissions}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/patient-list`}
      component={PatientList}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/patient-display-profile`}
      component={ShowPatientInformation}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/search-clinic-history`}
      component={SearchClinicHistory}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/clinic-history`}
      component={ClinicHistoryView}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/clinic-history2`}
      component={ClinicHistoryViewIps}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/clinic-history3`}
      component={ClinicHistoryViewNuclear}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/clinic-history4`}
      component={ClinicHistoryArdila}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/clinic-history5`}
      component={ClinicHistoryControl}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/files-admission`}
      component={AttachFileAdmission}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/receipt-admission`}
      component={ReceiptAdmission}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/add-admission`}
      component={AddAdmission}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/eventadverse`}
      component={EventAdverse}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/addeventadverse`}
      component={EventAdverseForm}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/geteventadverse`}
      component={GetEventAdverse}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/reporteventadverse`}
      component={ReportEventAdvers}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/interview`}
      component={Interview}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/daicoms`}
      component={DaicomViewer}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/dicomv2`}
      component={DicomViewerV2}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/historyfull`}
      component={ClinicHistoryComplete}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/upload-diagnostic-images`}
      component={ImagingFileAdmision}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/complaints-claims`}
      component={ComplaintsAndClaims}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/form-complaints-claims`}
      component={FormComplaintsAndClaims}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/survey-patients`}
      component={SurveyPatients}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/assitencial/event-adverse`}
      component={ClinicalStudioEventAdverse}
    />
  </Switch>
);

const Management = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/schedule`}
      component={ExamplePageTwo}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/search-invoice-costumer`}
      component={InvoiceCostumer}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/search-debit-notes`}
      component={DebitNotes}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/view-invoice`}
      component={ViewInvoice}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/search-receipts`}
      component={ReceiptsList}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/accounting-accounts`}
      component={AccountingAccount}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/payments`}
      component={Payments}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/billfold`}
      component={BillfoldPortfolio}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/retentions`}
      component={Retention}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/accounting-accounts-reports`}
      component={AccountsReport}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/financial-status-account`}
      component={AccountStatusProfile}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/advanced-payment`}
      component={AdvancePayment}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/patients-pending-invoice`}
      component={PatientsPendingInvoice}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/management/credit-notes`}
      component={CreditNotes}
    />
  </Switch>
);

const Strategic = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/indicators`}
      component={Indicators}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/reports`}
      component={Reports}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/report-patients`}
      component={ReportsPatients}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/settlement`}
      component={Settlement}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/rips`}
      component={RIPS}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/specific-rips`}
      component={RIPSpecificParameters}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/strategic/quality-indicators`}
      component={QualityIndicators}
    />
  </Switch>
);

const BillingView = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/view/invoice-generator`}
      component={InvoiceGenerator}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/view/invoices`}
      component={InvoiceList}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/view/settings`}
      component={Settings}
    />
  </Switch>
);

const documentManagement = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/document-retention`}
      component={DocumentManagementModule}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/documentation`}
      component={Documentation}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/version_history`}
      component={ChangeHistory}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/consult_documentos`}
      component={ConsultDocumentos}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/role-management`}
      component={GdRoleManagement}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/radication-external-documents`}
      component={GdExternalDocumentation}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/document-management/gestion-documento`}
      component={GdGestionDocumentos}
    />
  </Switch>
);

const wrappedRouteBillingView = () => (
  <React.Fragment>
    <Navbar />
    <div className="container-fluid mt-3">
      <Suspense fallback={<div>Loading...</div>}>
        <PrivateRoute
          path={`${process.env.PUBLIC_URL}/view`}
          component={BillingView}
        />
      </Suspense>
    </div>
  </React.Fragment>
);

const ProfileRoutes = () => (
  <Switch>
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/profile/account`}
      component={UserProfile}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/profile/calendar`}
      component={UserCalendar}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/profile/tasks`}
      component={Todo}
    />
    <PrivateRoute
      path={`${process.env.PUBLIC_URL}/profile/change-pass`}
      component={ChangePassword}
    />
  </Switch>
);

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/pages`}
        component={Pages}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/config`}
        component={Config}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/admin`}
        component={Admin}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/assitencial`}
        component={Assistencial}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/management`}
        component={Management}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/strategic`}
        component={Strategic}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/radio-pharmacy/operations-diary`}
        component={ReportOperationsDiary}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/profile`}
        component={ProfileRoutes}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/inventory`}
        component={Inventory}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/expenses`}
        component={Expenses}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/manual-invoice`}
        component={ManualInvoice}
      />
      <PrivateRoute
        path={`${process.env.PUBLIC_URL}/document-management`}
        component={documentManagement}
      />
    </div>
  </div>
);

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      return fakeAuth.isAuthenticated === true ? (
        <Component {...props} />
      ) : (
        <Redirect to={`${process.env.PUBLIC_URL}/log_in`} />
      );
    }}
  />
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route path={`${process.env.PUBLIC_URL}/log_in`} component={LogIn} />
        <Route
          path={`${process.env.PUBLIC_URL}/register`}
          component={Register}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/reset_password`}
          component={ResetPassword}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/patients-call`}
          component={PatientsCall}
        />

        <PrivateRoute path="/view" component={wrappedRouteBillingView} />
        <PrivateRoute
          path={`${process.env.PUBLIC_URL}/`}
          component={wrappedRoutes}
        />
        <Route path="*" component={NotFound404} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
